export enum BudgetStep {
    ASSIGN_OWNERS = 'ASSIGN_OWNERS',
    WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
    REQUEST_CHANGES = 'REQUEST_CHANGES',
    WAITING_OFFLINE_APPROVAL = 'WAITING_OFFLINE_APPROVAL',
    COMPLETE = 'WAITING_OFFLINE_APPROVAL',
}
